import { onError } from "@apollo/client/link/error";

import { markSessionExpired } from "./session-guard-vars";

/**
 * Marks this tab's session expired on an HTTP 401.
 *
 * Every tab shares one session cookie scoped to `.cadmus.io`, so an admin
 * impersonation, LTI launch, or Respondus entry in any other tab replaces it
 * wholesale. This tab keeps sending its original headers against a session
 * that is no longer its own, and pantheon answers 401.
 *
 * Only a 401 counts. An UNAUTHORIZED code on a 200 response is an
 * authorization failure for a perfectly healthy session, not an expired one.
 *
 * This link only classifies. Errors pass through untouched to
 * `ErrorLoggerLink`, which still reports them to Sentry.
 */
export const SessionGuardLink = onError(({ networkError }) => {
  if (networkError == null || networkError.name === "AbortError") return;

  if ("statusCode" in networkError && networkError.statusCode === 401) {
    markSessionExpired();
  }
});
